<template>
<div class="upload-ticket-page page-with-tabbar">
    <van-nav-bar title="订单详情" fixed :placeholder="true" left-arrow @click-left="goBack" />
    <!-- 顶部订单信息区 -->
    <div class="order-info-card">
        <div class="order-info-top">
            <div class="order-info-row">
                <span class="cinema-name">{{ order.cinemaName }}</span>
                <span class="city-name">{{ order.cityName }}</span>
            </div>
            <div class="order-info-row">
                <span class="order-id-group">
                    <span class="order-id">{{ order.id }}</span>
                    <span class="copy-btn" @click="copyOrderId(order.id)">复制</span>
                </span>
                <span class="distance-tag">
                    距开场
                    <van-count-down v-if="order.remainTime" :time="order.remainTime * 1000" format="mm:ss" class="distance-countdown" />
                </span>
            </div>
        </div>
        <div class="movie-info-row">
            <van-image width="80px" height="100px" fit="cover" :src="order.logo + '_200x200'" />
            <div class="movie-info-detail">
                <div class="movie-title-row">
                    <div class="movie-title">{{ order.movieName }}</div>
                    <span class="copy-order-btn" @click="copyOrder(order)">复制整单</span>
                </div>
                <div class="showtime-row">
                    <span class="today-tag" v-if="order.playDateTag">{{ order.playDateTag }}</span>
                    <span class="showtime">{{ order.playTimeText }}</span>
                </div>
                <div class="hall-name" v-if="order.hallName">{{ order.hallName }}</div>
                <div class="movie-tags">
                    <span class="ticket-count">{{ order.quantity }}张</span>
                    <span v-if="order.supportExchangeSeat === 'Y'" class="seat-type-tag seat-type-tag-clickable" @click="showSeatMap">九宫格换座</span>
                    <span v-if="order.seatTag === '2'" class="seat-type-tag couple-seat">情侣座</span>
                </div>
            </div>
        </div>
        <div class="address-row">
            <van-icon name="location-o" class="address-icon" />
            {{ order.cinemaAddress }}
            <van-button size="mini" v-if="order.channel =='taobao'" class="seat-map-btn" @click="getSeatPic">座位图</van-button>
        </div>
    </div>

    <!-- 座位信息区 -->
    <div class="seat-info-card">
        <div class="seat-title">
            <span>座位信息</span>
            <span class="seat-unlock">
                <van-icon name="lock" /> 已解锁座位</span>
        </div>
        <div class="seat-list">
            <van-tag v-for="seat in seatList" :key="seat" type="primary" size="medium" class="seat-tag">{{ seat }}</van-tag>
        </div>
    </div>
    <!-- 价格信息区 -->
    <div class="price-info-card">
        <div class="price-row">
            <span>市场价格：[仅供参考]</span>
            <span class="price-value">￥{{ order.channelUnitPrice }}/张</span>
        </div>
        <div class="price-row">
            <span>订单结算：</span>
            <div>
                <span class="order-total">￥{{ order.orderAmount }}</span>
                <span class="order-total-desc">(￥{{ order.orderUnitPrice }}/张)</span>
            </div>
        </div>
        <div class="price-row">
            <span>上报截止：</span>
            <span class="price-value">{{ order.expireTime }}</span>
        </div>
    </div>
    <!-- 上传取票码区 -->
    <div class="upload-section">
        <div class="section-title">上传取票码</div>
        <!-- <div class="section-tip">
            请仔细核对取票码是否正确，且务必按真实下单座位上报，取票码错误或座位不符引起损失需自行承担！
        </div> -->
        <div class="section-tip">
            请仔细核对取票码是否正确，且务必按真实下单座位上报，取票码错误或座位非真实出票座位引起损失需自行承担！
        </div>
        <div class="ticket-code-list" style="flex-direction: column; gap: 12px;">
            <div v-for="(item, idx) in ticketList" :key="idx" class="ticket-code-upload-item" style="display: flex; flex-direction: column; gap: 12px;">
                <!-- 上传图片和输入框行 -->
                <div style="display: flex; align-items: flex-start; gap: 12px;">
                    <!-- 左侧上传图片 -->
                    <van-uploader v-model="item.image" :max-count="1" :multiple="false" :max-size="10 * 1024 * 1024" :after-read="file => onAfterRead(file, idx)" :before-delete="(file, detail) => onBeforeDelete(idx, file, detail)" preview-size="80px" class="custom-uploader large-uploader">
                        <template #default>
                            <div class="uploader-plus large-plus">
                                <span>+</span>
                            </div>
                        </template>
                    </van-uploader>
                    <!-- 右侧输入框 -->
                    <div style="flex:1; display:flex; flex-direction:column; gap:6px;">
                        <!-- <van-field v-model="item.seats" label="座位" placeholder="如10排8座,10排9座" /> -->
                        <van-field v-model="item.code" label="取票码" placeholder="请输入取票码" />
                        <van-field v-model="item.verify" label="验证码" placeholder="请输入验证码（无可不填）" />
                    </div>
                    <!-- <van-icon name="cross" style="margin-left:8px;cursor:pointer;" v-if="ticketList.length>1" @click="removeTicketGroup(idx)" /> -->
                </div>

                <!-- 座位选择行 -->
                <div v-if="item.image.length > 0" class="seat-selection-row">
                    <div class="seat-options">
                        <div v-for="seat in item.seatListCopy" :key="seat" class="seat-option" :class="{ 'selected': item.selectedSeats.includes(seat) }" @click="toggleSeatSelection(idx, seat)">
                            <div class="checkbox-icon">
                                <van-icon :name="item.selectedSeats.includes(seat) ? 'success' : 'circle'" size="8" :class="{ 'selected-icon': item.selectedSeats.includes(seat), 'unselected-icon': !item.selectedSeats.includes(seat) }" />
                            </div>
                            <span class="seat-text">{{ seat }}</span>
                            <van-icon name="edit" class="edit-icon" size="8" @click.stop="openSeatEditDialog(idx, seat)" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="add-ticket-group" @click="addTicketGroup" style="margin:12px 0;display:flex;align-items:center;cursor:pointer;color:#409eff;">
                <van-icon name="plus" /> <span style="margin-left:4px;">添加一组</span>
            </div> -->
        </div>
    </div>

    <!-- 原座位信息块 -->
    <div v-if="order.seatsSrc" class="original-seats-card">
        <div class="original-seats-title">原座位信息</div>
        <div class="original-seats-list">
            <van-tag v-for="seat in originalSeatsList" :key="seat" type="primary" size="medium" class="original-seat-tag">
                {{ seat }}
            </van-tag>
        </div>
    </div>

    <!-- 上报说明卡片 -->
    <div class="report-desc-card">
        <div class="desc-title">上报说明</div>
        <ol class="desc-list">
            <li>1. 若识别失败，请手动输入每张图对应的票信息</li>
            <li>2. 若为短信，上传短信截图，手动填写取票码</li>
            <li>3. 若是有取票码和验证码的格式，可以分别填写，验证码不填默认没有</li>
        </ol>
    </div>
    <!-- 底部操作栏 -->
    <div class="bottom-bar">
        <div class="abandon-btn" :class="{ 'disabled': isTimeExpired }" @click="abandonOrder" :style="{ pointerEvents: isTimeExpired ? 'none' : 'auto' }">
            <van-icon name="delete-o" class="abandon-icon" />
            <div class="abandon-text">弃单</div>
        </div>
        <van-button class="report-btn" type="danger" :disabled="isTimeExpired" @click="submitReport">
            <span class="report-btn-content">
                <span>上报</span>
                <van-count-down v-if="order.remaining && !isTimeExpired" :time="order.remaining * 1000" format="mm:ss" class="report-countdown" @finish="onTimeExpired" />
            </span>
        </van-button>
    </div>
    <!-- van-popup弹窗放在根div内，避免多根元素 -->
    <van-popup v-model="showSpaceImage" position="center" :close-on-click-overlay="true" class="space-image-popup">
        <div class="popup-img-wrap">
            <img :src="srcImage" alt="座位图" class="popup-img" />
            <van-icon name="cross" class="popup-close" @click="closeSpaceImage" />
        </div>
    </van-popup>

    <!-- 座位编辑弹框 -->
    <van-popup v-model="showSeatEditDialog" position="center" :close-on-click-overlay="true" class="seat-edit-popup">
        <div class="seat-edit-content">
            <div class="seat-edit-title">选择座位</div>

            <!-- 后端返回的座位选择 -->
            <div class="recognized-seats-section">
                <!-- <div class="section-title">识别到的座位：</div> -->
                <div class="recognized-seats-list">
                    <div v-for="seat in currentRecognizedSeats" :key="seat" class="recognized-seat-item" :class="{ 'selected': selectedRecognizedSeat === seat }" @click="selectRecognizedSeat(seat)">
                        <van-icon :name="selectedRecognizedSeat === seat ? 'success' : 'circle-o'" :class="{ 'selected-icon': selectedRecognizedSeat === seat }" />
                        <span>{{ seat }}</span>
                    </div>
                </div>
            </div>

            <!-- 手动输入座位 -->
            <div class="manual-seat-section">
                <div class="section-title">手动输入座位：</div>
                <div class="seat-input-row">
                    <van-field v-model="manualRowInput" placeholder="排数" class="row-input" type="text" @input="handleRowInput"  @blur="formatInput('row')" maxlength="2" inputmode="latin" ref="rowField" />
                    <span class="seat-separator">排</span>
                    <van-field v-model="manualSeatInput" placeholder="座位号" class="seat-input" type="text" @input="handleSeatInput" @blur="formatInput('seat')" maxlength="3" inputmode="latin" ref="seatField" />
                    <span class="seat-separator">座</span>
                </div>
            </div>

            <!-- 确认按钮 -->
            <div class="seat-edit-actions">
                <van-button type="default" @click="cancelSeatEdit">取消</van-button>
                <van-button type="primary" @click="confirmSeatEdit">确认</van-button>
            </div>
        </div>
    </van-popup>
</div>
</template>

<script>
import Api from '@/api-service';
import {
    Toast,
    Dialog
} from 'vant';
export default {
    name: 'UploadTicketCode',
    data() {
        return {
            order: {},
            ticketList: [],
            scanMode: false,
            showSeatMapDialog: false,
            showSpaceImage: false,
            spaceImage: "https://img.piaoxiaodan.com/ticket/20241208/20241208001120_747188050.png",
            srcImage: '',
            isTimeExpired: false,
            showSeatEditDialog: false,
            currentRecognizedSeats: [],
            selectedRecognizedSeat: null,
            manualSeatInput: '',
            manualRowInput: '', // 新增：手动输入的排数
            currentTicketIndex: null, // 新增：当前正在编辑的票组索引
            currentEditSeat: '' // 新增：当前正在编辑的座位
        };
    },
    created() {
        // 只接收order_id
        const orderId = this.$route.query.order_id || this.$route.params.order_id;
        if (!orderId) {
            Toast.fail('未获取到订单号');
            return;
        }
        Api.getOrderDetail({
            id: orderId
        }).then(res => {
            if (res) {
                this.order = res;
                // ticketList初始化，自动回显图片和输入框
                if (this.order && this.order.quantity) {
                    // 创建座位列表副本
                    const seatListCopy = this.order.seats ? this.order.seats.split(',').map(seat => seat.trim()) : [];

                    this.ticketList = Array.from({
                        length: this.order.quantity
                    }).map((_, idx) => ({
                        image: this.order.ticketImgList && this.order.ticketImgList[idx] ?
                            [this.order.ticketImgList[idx]] :
                            [],
                        seats: this.order[`seat${idx + 1}`] || '',
                        code: this.order[`xlh${idx + 1}`] || '',
                        verify: this.order[`yzm${idx + 1}`] || '',
                        tips: this.order[`tips${idx + 1}`] || '',
                        selectedSeats: this.order[`seats${idx + 1}`] ? this.order[`seats${idx + 1}`].split('|') : [], // seats按|分割，转换为数组
                        recognizedSeats: [], // 新增：后端返回的座位列表
                        seatListCopy: [...seatListCopy] // 新增：座位列表副本
                    }));
                } else {
                    this.ticketList = [];
                }
                console.log('ticketList:', this.ticketList);
            } else {
                Toast.fail('订单信息获取失败');
            }
        }).catch(() => {
            Toast.fail('订单信息获取失败');
        });
    },
    computed: {
        remaining() {
            if (!this.order.expire_time) return 0;
            const now = Date.now();
            const expire = new Date(this.order.expire_time).getTime();
            const remaining = Math.max(0, Math.floor((expire - now) / 1000));

            // 如果时间已过期，设置状态
            if (remaining <= 0 && !this.isTimeExpired) {
                this.isTimeExpired = true;
            }

            return remaining;
        },
        seatList() {
            if (!this.order.seats) return [];
            return this.order.seats.split(',').map(seat => seat.trim());
        },
        originalSeatsList() {
            if (!this.order.seatsSrc) return [];
            return this.order.seatsSrc.split(',').map(seat => seat.trim());
        },
        formattedExpireTime() {
            if (!this.order.expire_time) return '未设置';
            // 处理时间戳，如果是秒级需要转换为毫秒级
            let timestamp = this.order.expire_time;
            if (timestamp < 1000000000000) {
                // 如果是秒级时间戳，转换为毫秒级
                timestamp = timestamp * 1000;
            }
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const result = `${year}-${month}-${day} ${hours}:${minutes}`;
            console.log('原始时间戳:', this.order.expire_time, '转换后:', result);
            return result;
        }
    },
    methods: {
        // 处理排数输入
        handleRowInput(value) {
            this.manualRowInput = value.toUpperCase(); // 实时转大写
        },

        // 处理座位号输入
        handleSeatInput(value) {
            this.manualSeatInput = value.toUpperCase(); // 实时转大写
        },

        // 格式化输入值（失焦时调用）
        formatInput(type) {
            const input = type === 'row' ?
                this.manualRowInput :
                this.manualSeatInput;

            // 清理特殊字符并转大写
            const cleaned = input.replace(/[^A-Z0-9]/g, '').toUpperCase();

            // 特殊处理：数字补零（如'1'变为'01'）
            const formatted = /^\d{1,2}$/.test(cleaned) ?
                cleaned.padStart(2, '0') :
                cleaned;

            if (type === 'row') {
                this.manualRowInput = formatted;
            } else {
                this.manualSeatInput = formatted;
            }
        },
        goBack() {
            this.$router.go(-1);
        },
        copyOrderId(orderId) {
            if (!orderId) return;
            if (navigator && navigator.clipboard) {
                navigator.clipboard.writeText(orderId).then(() => {
                    Toast('复制成功');
                });
            }
        },
        copyOrder(order) {
            const content = `订单号：${order.id || ''}\n城市：${order.cityName || ''}\n影院名字：${order.cinemaName || ''}\n影院地址：${order.cinemaAddress || ''}\n影片：${order.movieName || ''}\n场次：${order.playTimeText || ''}\n影厅：${order.hallName || ''}\n座位：${order.seats || ''}\n市场价：${order.channelUnitPrice || ''}`;
            navigator.clipboard.writeText(content.trim()).then(() => {
                Toast.success('内容已复制到剪贴板');
            }).catch(() => {
                Toast.fail('复制失败');
            });
        },
        addTicketGroup() {
            this.ticketList.push({
                image: [],
                seats: '',
                code: '',
                verify: '',
                tips: ''
            });
        },
        removeTicketGroup(idx) {
            this.ticketList.splice(idx, 1);
        },
        delayOrder() {
            Toast('延迟订单功能开发中');
        },
        submitReport() {
            // 验证是否有至少一张图片和对应的取票码
            const hasValidData = this.ticketList.some((item, index) => {
                return item.image.length > 0 && item.code && item.code.trim() !== '';
            });

            if (!hasValidData) {
                this.$toast.fail('请至少上传一张取票码图片并填写对应的取票码');
                return;
            }

            // 检查已上传图片的取票码是否完整
            const incompleteData = this.ticketList.some((item, index) => {
                // 如果上传了图片但没有填写取票码，则提示
                if (item.image.length > 0 && (!item.code || item.code.trim() === '')) {
                    this.$toast.fail(`请为第${index + 1}张图片填写取票码`);
                    return true;
                }
                return false;
            });

            if (incompleteData) {
                return;
            }

            // 检查座位选择是否完整
            const incompleteSeats = this.ticketList.some((item, index) => {
                // 如果上传了图片但没有选择座位，则提示
                if (item.image.length > 0 && item.code && item.selectedSeats.length === 0) {
                    this.$toast.fail(`请为第${index + 1}张图片选择对应的座位`);
                    return true;
                }
                return false;
            });

            if (incompleteSeats) {
                return;
            }

            // 检查座位个数是否一致：每个图片selectedSeats的座位个数总和，与原始的this.seatList座位个数是否一致，如果一致，则可以上报，如果不一致，则提示
            const seatList = this.seatList;
            const ticketList = this.ticketList;
            console.log('seatList:', seatList);
            console.log('ticketList:', ticketList);
            const selectedSeats = ticketList.map(item => item.selectedSeats.length).reduce((a, b) => a + b, 0);
            if (selectedSeats !== seatList.length) {
                this.$toast.fail(`座位个数不一致，请检查座位选择`);
                return;
            }

            // 组装上报数据，参考OrderDetail页面的逻辑
            const reportData = {
                ...this.order
            };

            // 处理图片URL列表 - 只包含有图片的项目
            const imageUrls = [];
            this.ticketList.forEach((item, index) => {
                if (item.image.length > 0) {
                    const imageUrl = item.image[0].url || item.image[0].content;
                    if (imageUrl) {
                        imageUrls.push(imageUrl);
                    }
                }
            });
            reportData.ticketImg = imageUrls.join(',');

            // 处理取票码和验证码字段 - 只处理有数据的项目
            this.ticketList.forEach((item, index) => {
                const xlhKey = `xlh${index + 1}`;
                const yzmKey = `yzm${index + 1}`;
                const tipsKey = `tips${index + 1}`;
                const seatsKey = `seats${index + 1}`;

                // 只设置有数据的字段，没有数据的保持为空
                if (item.image.length > 0 && item.code) {
                    reportData[xlhKey] = item.code || '';
                    reportData[yzmKey] = item.verify || '';
                    reportData[seatsKey] = item.selectedSeats.join('|') || ''; // 使用选中的座位
                    reportData[tipsKey] = item.tips || '';
                } else {
                    // 清空没有数据的字段
                    reportData[xlhKey] = '';
                    reportData[yzmKey] = '';
                    reportData[tipsKey] = '';
                    reportData[seatsKey] = '';
                }
            });

            // console.log('上报数据:', reportData);
            // return;

            // 调用上报接口
            const toast = this.$toast.loading({
                duration: 90000,
                forbidClick: false,
                overlay: true,
                message: '上报中，请耐心等待',
            });

            Api.uploadOrderTicketCode(reportData).then(res => {
                toast.clear();
                this.$toast.success('上报成功');

                // 上报成功后返回上一页
                setTimeout(() => {
                    this.goBack();
                }, 1500);
            }).catch(err => {
                toast.clear();
                this.$toast.fail('上报失败，请重试');
                console.error('上报失败:', err);
            });
        },
        showSeatMap() {
            console.log('showSeatMap clicked');
            this.showSpaceImage = true;
            this.srcImage = this.spaceImage;
        },
        closeSpaceImage() {
            this.showSpaceImage = false;
        },
        onAfterRead(file, idx) {
            this.uploadImage(file, idx);
        },
        uploadImage(file, idx) {
            const toast = this.$toast.loading({
                duration: 60000,
                forbidClick: false,
                overlay: true,
                message: '上传中，请耐心等待',
            });

            Api.uploadImage({
                file: file.file,
                type: '4',
                order_id: this.order.id
            }).then(res => {
                toast.clear();
                console.log(res);

                // 直接使用传入的索引，确保图片上传到用户点击的控件
                const targetIndex = idx;

                console.log('上传目标索引:', targetIndex, '传入索引:', idx, '更新前:', this.ticketList[targetIndex]);

                // 更新图片
                this.$set(this.ticketList, targetIndex, {
                    image: [res],
                    code: '',
                    verify: '',
                    seats: '',
                    tips: '',
                    selectedSeats: [], // 上传成功后清空选中的座位
                    recognizedSeats: res.seats ? Array.isArray(res.seats) ? res.seats : [res.seats] : [], // 保存后端返回的座位
                    seatListCopy: [...this.seatList],
                });

                console.log('更新目标索引:', targetIndex, '更新后的项目:', this.ticketList[targetIndex]);

                // 自动填充识别结果
                if (res.code && res.code.length > 0) {
                    const arr = res.code.split('|');
                    if (arr.length === 1) {
                        // 只有取票码
                        this.$set(this.ticketList[targetIndex], 'code', arr[0]);
                    } else {
                        // 取票码和验证码
                        this.$set(this.ticketList[targetIndex], 'code', arr[0]);
                        this.$set(this.ticketList[targetIndex], 'verify', arr[1]);
                    }
                }

                // 填充座位信息
                if (res.seat_cnt) {
                    this.$set(this.ticketList[targetIndex], 'seats', res.seat_cnt);
                }
                console.log('res.seats:', res.seats);

                // 根据服务器返回的座位号自动勾选匹配的座位
                if (res.seats) {
                    // 服务器返回的seats是数组格式
                    const recognizedSeats = this.ticketList[targetIndex].recognizedSeats;
                    // 为每个上传组件创建独立的座位列表副本
                    const seatListCopy = this.ticketList[targetIndex].seatListCopy;
                    const matchedSeats = seatListCopy.filter(seat => recognizedSeats.includes(seat));
                    console.log('recognizedSeats:', recognizedSeats);
                    console.log('seatListCopy:', seatListCopy);
                    console.log('matchedSeats:', matchedSeats);
                    this.$set(this.ticketList[targetIndex], 'selectedSeats', matchedSeats);
                }

                console.log('填充后目标项目:', this.ticketList[targetIndex]);

                // 处理比对结果
                if (res.match_type !== 1) {
                    // 比对有误
                    if (res.match_type === 2) {
                        // 比对失败，弹对话框
                        this.$toast.error('核对失败：' + (res.tips || '识别结果与订单信息不匹配'));
                    } else if (res.data && res.data.tips) {
                        this.$toast.warning(res.data.tips);
                    }

                    // 保存tips信息
                    if (res.tips) {
                        this.$set(this.ticketList[targetIndex], 'tips', res.tips);
                    } else if (res.data && res.data.tips) {
                        this.$set(this.ticketList[targetIndex], 'tips', res.data.tips);
                    }
                }

                // 同步更新 order 对象中的字段
                this.ticketList.forEach((item, index) => {
                    const xlhKey = `xlh${index + 1}`;
                    const yzmKey = `yzm${index + 1}`;
                    const seatKey = `seat${index + 1}`;
                    const tipsKey = `tips${index + 1}`;

                    this.order[xlhKey] = item.code;
                    this.order[yzmKey] = item.verify;
                    this.order[seatKey] = item.seats;
                    this.order[tipsKey] = item.tips || '';
                });

                console.log('上传后ticketList:', this.ticketList);

                // 强制触发 Vue 的响应式更新
                this.$forceUpdate();

                this.$toast.success('上传成功');
            }).catch(err => {
                toast.clear();
                this.$toast.error('上传失败');
                console.error('上传失败:', err);
            });
        },

        onBeforeDelete(idx, file, detail) {
            console.log('删除前ticketList:', this.ticketList);
            console.log('删除索引:', idx, '删除的文件:', file);

            // 删除当前图片和对应的取票码信息
            this.$set(this.ticketList, idx, {
                image: [],
                code: '',
                verify: '',
                seats: '',
                tips: '',
                selectedSeats: [], // 删除时也清空选中的座位
                recognizedSeats: [], // 删除时也清空后端返回的座位
                seatListCopy: [...this.seatList] // 删除时重新创建座位列表副本
            });

            // 检查后面是否还有其他图片，如果有才上移
            const size = this.ticketList.length;
            let hasContentAfter = false;
            for (let i = idx + 1; i < size; i++) {
                if (!this.isItemEmpty(this.ticketList[i])) {
                    hasContentAfter = true;
                    break;
                }
            }

            // 只有当后面有内容时才上移
            if (hasContentAfter) {
                this.handleContentShift();
            }

            // 同步更新 order 对象中的字段
            this.ticketList.forEach((item, index) => {
                const xlhKey = `xlh${index + 1}`;
                const yzmKey = `yzm${index + 1}`;
                const seatKey = `seat${index + 1}`;
                const tipsKey = `tips${index + 1}`;

                this.order[xlhKey] = item.code;
                this.order[yzmKey] = item.verify;
                this.order[seatKey] = item.seats;
                this.order[tipsKey] = item.tips || '';
            });

            console.log('删除后ticketList:', this.ticketList);

            return true; // 允许 van-uploader 正常删除
        },

        // 处理内容上移
        handleContentShift() {
            console.log('处理内容上移');
            console.log('上移前ticketList:', JSON.parse(JSON.stringify(this.ticketList)));

            const size = this.ticketList.length;

            // 从前往后遍历，找到第一个空位置
            for (let i = 0; i < size - 1; i++) {
                if (this.isItemEmpty(this.ticketList[i])) {
                    console.log('找到空位置:', i);
                    // 找到空位置，将后续第一个有内容的项目上移
                    for (let j = i + 1; j < size; j++) {
                        if (!this.isItemEmpty(this.ticketList[j])) {
                            console.log('将位置', j, '的内容移动到位置', i);
                            // 将第j个位置的内容移动到第i个位置
                            this.$set(this.ticketList, i, {
                                image: [...this.ticketList[j].image], // 深拷贝图片数组
                                code: this.ticketList[j].code,
                                verify: this.ticketList[j].verify,
                                seats: this.ticketList[j].seats,
                                tips: this.ticketList[j].tips || '',
                                selectedSeats: this.ticketList[j].selectedSeats, // 深拷贝选中的座位
                                recognizedSeats: this.ticketList[j].recognizedSeats, // 深拷贝后端返回的座位
                                seatListCopy: [...this.ticketList[j].seatListCopy] // 深拷贝座位列表副本
                            });

                            // 清空第j个位置
                            this.$set(this.ticketList, j, {
                                image: [],
                                code: '',
                                verify: '',
                                seats: '',
                                tips: '',
                                selectedSeats: [], // 清空选中的座位
                                recognizedSeats: [], // 清空后端返回的座位
                                seatListCopy: [...this.seatList] // 重新创建座位列表副本
                            });

                            console.log('移动完成，当前ticketList:', JSON.parse(JSON.stringify(this.ticketList)));
                            break; // 只移动一个项目
                        }
                    }
                }
            }

            // 同步更新 order 对象中的字段
            this.ticketList.forEach((item, index) => {
                const xlhKey = `xlh${index + 1}`;
                const yzmKey = `yzm${index + 1}`;
                const seatKey = `seat${index + 1}`;
                const tipsKey = `tips${index + 1}`;

                this.order[xlhKey] = item.code;
                this.order[yzmKey] = item.verify;
                this.order[seatKey] = item.seats;
                this.order[tipsKey] = item.tips || '';
            });

            console.log('上移后的 ticketList:', this.ticketList);
        },
        abandonOrder() {
            if (this.isTimeExpired) {
                this.$toast('订单已结束，无法弃单');
                return;
            }

            // 确认弃单
            this.$dialog.confirm({
                title: '确认弃单',
                message: '确定要弃单吗？弃单后无法恢复。',
                confirmButtonText: '确定弃单',
                cancelButtonText: '取消',
                confirmButtonColor: '#ff2c54'
            }).then(() => {
                // 用户确认弃单
                const toast = this.$toast.loading({
                    duration: 10000,
                    forbidClick: false,
                    overlay: true,
                    message: '弃单中，请稍候',
                });

                Api.cancelOrder({
                    order_id: this.order.id
                }).then(res => {
                    toast.clear();
                    this.$toast.success('弃单成功');

                    // 弃单成功后返回上一页
                    setTimeout(() => {
                        this.goBack();
                    }, 1500);
                }).catch(err => {
                    toast.clear();
                    this.$toast.fail('弃单失败，请重试');
                    console.error('弃单失败:', err);
                });
            }).catch(() => {
                // 用户取消弃单
                console.log('用户取消弃单');
            });
        },
        onTimeExpired() {
            this.isTimeExpired = true;
            this.$toast('订单时间已结束');
        },
        async getSeatPic() {
            if (!this.order.id) {
                this.$toast('订单信息有误');
                return;
            }
            try {
                const res = await Api.getSeatPic({
                    order_id: this.order.id
                });
                console.log(res);
                if (res && res.url) {
                    console.log(res.url);
                    this.srcImage = res.url;
                    this.showSpaceImage = true;
                } else {
                    this.$toast('未获取到座位图');
                }
            } catch (e) {
                this.$toast('获取座位图失败');
            }
        },
        isItemEmpty(item) {
            // 如果图片为空，则认为是空项目
            if (item.image.length === 0) {
                return true;
            }
            // 如果有图片但没有取票码，也认为是空项目（需要用户填写）
            if (item.image.length > 0 && (!item.code || item.code.trim() === '')) {
                return true;
            }
            // 其他情况认为是有内容的项目
            return false;
        },
        toggleSeatSelection(idx, seat) {
            const item = this.ticketList[idx];
            const currentSeats = [...item.selectedSeats];
            const seatIndex = currentSeats.indexOf(seat);

            if (seatIndex > -1) {
                currentSeats.splice(seatIndex, 1);
            } else {
                currentSeats.push(seat);
            }
            this.$set(this.ticketList, idx, {
                ...item,
                selectedSeats: currentSeats
            });
        },
        openSeatEditDialog(idx, seat) {
            this.currentTicketIndex = idx;
            this.currentEditSeat = seat; // 保存当前正在编辑的座位
            // 显示后端返回的座位，如果没有则显示当前选中的座位
            const item = this.ticketList[idx];
            this.currentRecognizedSeats = item.recognizedSeats || item.selectedSeats || [];
            this.selectedRecognizedSeat = null;
            this.manualSeatInput = '';
            this.manualRowInput = ''; // 清空排数输入框
            this.showSeatEditDialog = true;
        },
        selectRecognizedSeat(seat) {
            this.selectedRecognizedSeat = seat;
            // 解析座位格式，填入输入框
            const match = seat.match(/(\d+)排(\d+)座/);
            if (match) {
                this.manualRowInput = match[1];
                this.manualSeatInput = match[2];
            } else {
                this.manualSeatInput = seat; // 如果不是标准格式，直接填入座位输入框
            }
        },
        cancelSeatEdit() {
            this.showSeatEditDialog = false;
            this.selectedRecognizedSeat = null;
            this.manualSeatInput = '';
            this.manualRowInput = ''; // 清空排数输入框
            this.currentTicketIndex = null;
            this.currentEditSeat = '';
        },
        confirmSeatEdit() {
            let finalSeat = '';

            if (this.selectedRecognizedSeat) {
                // 选择了后端返回的座位
                finalSeat = this.selectedRecognizedSeat;
            } else if (this.manualRowInput && this.manualSeatInput) {
                // 手动输入了排数和座位号
                finalSeat = `${this.manualRowInput}排${this.manualSeatInput}座`;
            }

            if (finalSeat) {
                // 使用当前票组的独立座位列表副本进行修改
                const item = this.ticketList[this.currentTicketIndex];
                const seatIndex = item.seatListCopy.findIndex(seat => seat === this.currentEditSeat);
                if (seatIndex !== -1) {
                    // 修改座位列表副本
                    const newSeatListCopy = [...item.seatListCopy];
                    newSeatListCopy[seatIndex] = finalSeat;
                    this.$set(this.ticketList[this.currentTicketIndex], 'seatListCopy', newSeatListCopy);
                }

                // 更新选中座位
                const selectedIndex = item.selectedSeats.findIndex(seat => seat === this.currentEditSeat);
                if (selectedIndex !== -1) {
                    const newSelectedSeats = [...item.selectedSeats];
                    newSelectedSeats[selectedIndex] = finalSeat;
                    this.$set(this.ticketList[this.currentTicketIndex], 'selectedSeats', newSelectedSeats);
                } else {
                    // 如果当前座位没有选中，则添加到选中座位列表，需要加上当前选择的座位
                    this.$set(this.ticketList[this.currentTicketIndex], 'selectedSeats', [...item.selectedSeats, finalSeat]);
                }
            }

            this.showSeatEditDialog = false;
            this.selectedRecognizedSeat = null;
            this.manualSeatInput = '';
            this.manualRowInput = '';
            this.currentTicketIndex = null;
            this.currentEditSeat = '';
        }
    }
};
</script>

<style lang="scss" scoped>
.upload-ticket-page {
    background: #f7f7fa;
    min-height: 100vh;
    padding: 6px 12px calc(50px + env(safe-area-inset-bottom, 0px)) 12px;

    .order-info-card {
        background: #fff;
        border-radius: 8px;
        padding: 12px;
        margin: 12px 0;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);

        .order-info-top {
            margin-bottom: 8px;
        }

        .order-info-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 2px;
        }

        .cinema-name {
            font-weight: bold;
            font-size: 16px;
            color: #222;
        }

        .city-name {
            font-size: 13px;
            color: #222;
            font-weight: bold;
        }

        .order-id-group {
            display: flex;
            align-items: center;
        }

        .order-id {
            margin-right: 8px;
            font-size: 13px;
        }

        .copy-btn {
            color: #409eff;
            cursor: pointer;
            font-size: 13px;
        }

        .distance-tag {
            background: #ffefef;
            color: #ff2c54;
            border-radius: 12px;
            font-size: 13px;
            padding: 2px 10px;
            font-weight: bold;
            min-width: 0;
            white-space: nowrap;
            text-align: center;
            display: inline-flex;
            align-items: center;
            gap: 4px;
            flex-shrink: 0;
            margin-left: auto;
        }

        .distance-countdown {
            color: #ff2c54 !important;
            font-weight: bold;
            font-size: 13px;
            margin-left: 4px;
        }
    }

    .movie-info-row {
        display: flex;
        align-items: flex-start;
        margin: 12px 0;

        .movie-info-detail {
            margin-left: 12px;
            flex: 1;
            min-width: 0;

            .movie-title-row {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            .movie-title {
                font-size: 15px;
                font-weight: 500;
                color: #333;
            }

            .copy-order-btn {
                margin-left: 12px;
                font-size: 12px;
                color: #888;
                cursor: pointer;
                align-self: center;
            }

            .showtime-row {
                font-size: 13px;
                color: #333;
                margin: 8px 0;
                display: flex;
                align-items: center;
                gap: 6px;
            }

            .today-tag {
                display: inline-block;
                color: white;
                background-color: #ff2c53da;
                font-size: 12px;
                font-weight: bold;
                padding: 2px 6px 2px 4px;
                margin-right: 2px;
                line-height: 1.2;
                vertical-align: middle;
                border-radius: 2px;
            }

            .hall-name {
                font-size: 13px;
                color: #888;
                margin-bottom: 2px;
            }

            .movie-tags {
                margin-top: 4px;
            }

            .ticket-count {
                background: #f7f8fa;
                border-radius: 8px;
                font-size: 10px;
                padding: 1px 1px;
            }

            .seat-type-tag {
                border: 2px solid rgb(0, 140, 255);
                color: rgb(0, 140, 255);
                border-radius: 2px;
                font-size: 10px;
                font-weight: bold;
                padding: 2px 2px;
                margin-left: 4px;
            }

            .couple-seat {
                border: 2px solid #ff2c54;
                color: #ff2c54;
                background-color: #fff2f0;
            }
        }
    }

    .address-row {
        display: flex;
        align-items: center;
        font-size: 13px;
        color: #888;
        margin: 10px 0;

        .address-icon {
            font-size: 16px;
            color: #ff2c54;
            margin-right: 4px;
        }

        .seat-map-btn {
            margin-left: auto;
            font-size: 12px;
            padding: 0 12px;
            height: 24px;
            line-height: 24px;
            border-radius: 12px;
            background: #f7f7fa;
            color: #409eff;
            border: none;
            min-width: 60px;
            white-space: nowrap;
        }
    }

    .price-info-card {
        background: #fff;
        border-radius: 8px;
        padding: 12px;
        margin: 8px 0;
        font-size: 14px;
        color: #333;

        .price-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 8px;
            font-size: 15px;

            .price-value {
                color: #222;
                font-weight: bold;
                margin-left: 8px;
            }

            .current-bid-price {
                color: #ff2c54;
            }

            .order-total {
                color: #ff2c54;
                font-weight: bold;
                font-size: 16px;
            }

            .order-total-desc {
                color: #888;
                font-size: 13px;
                margin-left: 4px;
            }
        }
    }

    .seat-info-card {
        background: #fff;
        border-radius: 8px;
        padding: 12px;
        margin: 8px 0;

        .seat-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-weight: bold;
            font-size: 15px;
            margin-bottom: 8px;

            .seat-unlock {
                color: #409eff;
                font-size: 13px;
                display: flex;
                align-items: center;
                gap: 2px;
            }
        }

        .seat-list {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;

            .seat-tag {
                margin-right: 8px;
                margin-bottom: 4px;
                background-color: #409eff !important;
                color: white !important;
                border-color: #409eff !important;
                font-size: 14px;
            }
        }
    }

    .upload-section {
        background: #fff;
        border-radius: 8px;
        padding: 12px;
        margin: 8px 0;

        .section-title {
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 8px;
        }

        .section-tip {
            color: #ff2c54;
            font-size: 13px;
            margin-bottom: 8px;
        }

        .ticket-code-list {
            display: flex;
            flex-direction: column;
            gap: 12px;
            /* 移除高度限制和滚动，完全展示所有内容 */
            padding-right: 4px;
            width: 100%;
            max-width: 100%;
        }

        .ticket-code-upload-item {
            display: flex;
            align-items: flex-start;
            gap: 12px;
        }

        .seat-selection-row {
            margin-top: 1px;

            .seat-options {
                display: flex;
                flex-wrap: wrap;
                gap: 12px;

                .seat-option {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    padding: 6px 6px;
                    border: 1px solid #010209;
                    border-radius: 6px;
                    background: #fff;
                    cursor: pointer;
                    transition: all 0.2s ease;

                    &:hover {
                        border-color: #409eff;
                    }

                    &.selected {
                        border-color: #409eff;
                        background: #e6f7ff;
                    }

                    .seat-text {
                        font-size: 15px;
                        color: #333;
                        flex: 1;
                    }

                    .edit-icon {
                        font-size: 12px;
                        color: #999;
                        margin-left: auto;
                    }

                    .checkbox-icon {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .unselected-icon {
                        color: #666;
                    }

                    .selected-icon {
                        color: green;
                        font-size: 16px;
                    }

                    .van-icon {
                        font-size: 14px;
                        color: #999;

                        &.selected-icon {
                            color: green;
                        }

                        &.unselected-icon {
                            color: #666;
                        }
                    }
                }
            }
        }
    }

    .original-seats-card {
        background: #fff;
        border-radius: 8px;
        margin: 12px 0;
        padding: 12px 16px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);

        .original-seats-title {
            font-weight: bold;
            font-size: 15px;
            margin-bottom: 12px;
            color: #333;
        }

        .original-seats-list {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;

            .original-seat-tag {
                margin: 0;
            }
        }
    }

    .report-desc-card {
        background: #fff;
        border-radius: 8px;
        margin: 8px 0;
        padding: 12px 16px 10px 12px;
        font-size: 14px;
        color: #333;
        padding-bottom: 100px;

        .desc-title {
            font-weight: bold;
            font-size: 15px;
            margin-bottom: 8px;
        }

        .desc-list {
            // padding-left: 18px;
            margin: 0;
            color: #888;
            font-size: 13px;

            li {
                margin-bottom: 4px;
                line-height: 1.7;
            }
        }
    }

    .bottom-bar {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 12px 12px 12px;
        background: #fff;
        box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.03);
        z-index: 10;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        padding-bottom: env(safe-area-inset-bottom, 0px);

        .abandon-btn {
            flex: 0 0 70px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 44px;
            background: #fff;
            border: 1.5px solid #ccc;
            color: #888;
            border-radius: 4px;
            cursor: pointer;

            .abandon-icon {
                font-size: 22px;
                margin-bottom: 2px;
            }

            .abandon-text {
                font-size: 13px;
                margin-top: 0;
            }

            &.disabled {
                background: #f5f5f5;
                border-color: #ddd;
                color: #ccc;
                cursor: not-allowed;

                .abandon-icon {
                    color: #ccc;
                }

                .abandon-text {
                    color: #ccc;
                }
            }
        }

        .report-btn {
            flex: 1;
            height: 44px;
            font-weight: bold;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

.custom-uploader {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafbfc;
    border: 1.5px dashed #bbb;
    border-radius: 8px;

    .uploader-plus {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        color: #bbb;
        font-weight: bold;
    }
}

.bordered-field {
    border: 1.5px solid #e5e6eb;
    border-radius: 0 !important;
    background: #fafbfc;
    padding: 0 8px;

    .van-field__control {
        background: transparent;
    }
}

.scrollable-upload-list {
    /* 移除高度限制和滚动，完全展示所有内容 */
    padding-right: 4px;
}

.tall-upload-item {
    min-height: 100px;
    align-items: center !important;
    gap: 20px !important;
}

.large-uploader {
    width: 80px !important;
    height: 80px !important;

    .uploader-plus,
    .large-plus {
        font-size: 40px !important;
    }
}

.tall-inputs {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: center;
}

.large-field {
    min-height: 45px;
    font-size: 12px;
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 100%;

    .van-field__body {
        gap: 0 !important;
        padding-left: 0 !important;
        margin-left: 0 !important;
    }

    .van-field__label {
        font-size: 15px;
        text-align: center;
        white-space: nowrap;
        padding: 0 !important;
        margin: 0 !important;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .van-field__control {
        flex: 1 1 0 !important;
        min-width: 0 !important;
        width: 0 !important;
        text-align: left !important;
        display: block !important;
        align-items: center;
        justify-content: flex-start;
        padding-left: 0.5em;
    }
}

/* 只做字体、对齐、nowrap微调，不再强行覆盖宽度 */
::v-deep(.large-field .van-field__label) {
    font-size: 14px;
    text-align: center;
    white-space: nowrap;
    padding: 0 !important;
    margin: 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

::v-deep(.large-field .van-field__body) {
    gap: 0 !important;
    padding-left: 0 !important;
    margin-left: 0 !important;
}

::v-deep(.large-field .van-field__control) {
    flex: 1 1 0 !important;
    min-width: 0 !important;
    width: 0 !important;
    text-align: left !important;
    display: block !important;
    align-items: center;
    justify-content: flex-start;
    padding-left: 0.5em;
}

/* 缩小取票码文字与输入框的间距 */
::v-deep(.van-field__label) {
    margin-right: 8px !important;
    min-width: 45px !important;
    max-width: 40px !important;
}

::v-deep(.van-field__body) {
    gap: 4px !important;
}

.space-image-popup {
    z-index: 9999 !important;

    .popup-img-wrap {
        position: relative;
        padding: 0;
        background: #fff;
        border-radius: 8px;
        max-width: 90vw;
        max-height: 80vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .popup-img {
        max-width: 90vw;
        max-height: 70vh;
        border-radius: 8px;
        display: block;
    }

    .popup-close {
        position: absolute;
        top: 8px;
        right: 8px;
        font-size: 28px;
        color: #888;
        cursor: pointer;
        background: #fff;
        border-radius: 50%;
        z-index: 2;
    }
}

.seat-edit-popup {
    z-index: 9999 !important;

    .seat-edit-content {
        background: #fff;
        border-radius: 12px;
        padding: 20px;
        width: 320px;
        max-width: 90vw;

        .seat-edit-title {
            font-size: 18px;
            font-weight: bold;
            text-align: center;
            margin-bottom: 20px;
            color: #333;
        }

        .recognized-seats-section {
            margin-bottom: 20px;

            .section-title {
                font-size: 14px;
                color: #666;
                margin-bottom: 12px;
            }

            .recognized-seats-list {
                display: flex;
                flex-wrap: wrap;
                gap: 12px;

                .recognized-seat-item {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    padding: 6px 6px;
                    border: 1px solid #010209;
                    border-radius: 6px;
                    background: #fff;
                    cursor: pointer;
                    transition: all 0.2s ease;

                    &:hover {
                        border-color: #409eff;
                    }

                    &.selected {
                        border-color: #409eff;
                        background: #e6f7ff;
                    }

                    .van-icon {
                        font-size: 8px;
                        color: #666;

                        &.selected-icon {
                            color: green;
                            font-size: 16px;
                        }
                    }

                    span {
                        font-size: 15px;
                        color: #333;
                        flex: 1;
                    }
                }
            }
        }

        .manual-seat-section {
            margin-bottom: 20px;

            .section-title {
                font-size: 14px;
                color: #666;
                margin-bottom: 12px;
            }

            .seat-input-row {
                display: flex;
                align-items: center;
                gap: 8px;

                .row-input,
                .seat-input {
                    flex: 1;
                    font-size: 14px;
                    border: 1px solid #e5e6eb;
                    border-radius: 6px;
                    padding: 8px 12px;
                    text-align: center;
                    min-width: 50px;
                    max-width: 80px;
                }

                .seat-separator {
                    font-size: 14px;
                    color: #333;
                }
            }
        }

        .seat-edit-actions {
            display: flex;
            gap: 12px;
            justify-content: flex-end;

            .van-button {
                min-width: 80px;
            }
        }
    }
}

.seat-grid-thumb {
    width: 32px;
    height: 32px;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid #eee;
    margin-left: 6px;
    vertical-align: middle;
}

.seat-type-tag-clickable {
    cursor: pointer;
    color: #007aff;
    text-decoration: underline;

    &:hover {
        color: #0056b3;
    }
}

.report-btn-content {
    display: flex;
    align-items: center;
    //   gap: 1px;
}

.report-countdown {
    color: #fff !important;
    font-weight: bold;
    font-size: 16px;
    margin-left: 6px;
}
</style>
